import { getNodeData as getNodeDataAction } from '@/store/modules/nodes/actions';
import { useStore } from '@/utils/store';
import { WorkflowNodeId } from '@ply-io/ply-front-shared-utilities';

export const useNodesActions = () => {
	const { dispatch } = useStore();
	return {
		getNodeData: (id: WorkflowNodeId, published?: boolean, forceGet?: boolean) =>
			dispatch<{ id: WorkflowNodeId; published?: boolean; forceGet?: boolean }, void>(getNodeDataAction, {
				id,
				published,
				forceGet,
			}),
	};
};
